module.exports = __webpack_public_path__ + "static/img/cover_1.6dc10a8c.png";